// apps/embed/src/entries/embedBuildEnv.ts
import type { StorefrontEnv } from '@tourtask/storefront/storefrontEnv';

/**
 * The embed build's environment as CRA inlines it at build time. Every entry hands it to `setStorefrontEnv`
 * before it mounts, so the `REACT_APP_*` reads live here, in the embed's own entries, and not in the tree a
 * TourTask site renders too.
 */
export const EMBED_BUILD_ENV: StorefrontEnv = {
	// Injected by the embed deploy workflow; a local craco build has none, and says so.
	buildId: process.env.REACT_APP_BUILD_SHA ?? 'dev',
	// A test build against PayPal's sandbox (see components/payments/paypalClient.ts).
	paypalSandbox: process.env.REACT_APP_PAYPAL_SANDBOX === 'true',
	// The widget loads Stripe.js while the visitor browses, for a business that may take payments in it
	// (docs/embed-size-and-speed.md §6.1 #3).
	preloadStripeJsWhileBrowsing: true,
};
